import React, { Fragment, useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
    Button,
    Checkbox,
    Chip,
    colors,
    Container,
    CssBaseline,
    FormControlLabel,
    FormGroup,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
    useStylesAutoPurch
    , useStylesUiElemment,
    useStylesSpDial,
    useStylesLbl,
    useStylesAutoSafe,
} from '../../../../St/Reports/UseStyle';
import AddIcon from "@material-ui/icons/Add";

import CircularProgress from "@material-ui/core/CircularProgress";
import {
    useStylesUp,
    useStylesHed,
    useStylesAuto,
    useStylesTF,
    useStylesTD,
    useStylesBA,
    useStylesFU,
    useStylesCAB,
    SaleCheckbox,
    useStylesDSM,
    useStylesDPM,
    StyledMenuItem,
    StyledMenu,
    useStylesSN,
    SaleSwitch,
} from "../../../../St/comps/UseStyle";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import StopIcon from "@material-ui/icons/Stop";
import QuestionAnswer from "@material-ui/icons/Update";
import { Update } from "@material-ui/icons";
import i18next from "i18next";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        // backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        fontWeight: "bold"
    },
    headerTitle2: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        direction: "rtl"
    },
    headerTitleP: {
        backgroundColor: colors.blue[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        direction: "rtl"
    },
    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.blue[300],
    },
}));

export default function RestHeader(props) {
    const {
        AutoOptions,
        isPurches,
        setting,
        handleOpenCustomer,
        changAutoCustomers
        , optionsCustomers,
        changAutoSalesMen,
        valueSalesmen,
        changAutoCostcenter,
        valueCostcenter,
        idata,
        changAutoType,
        valueType,
        valueSafes,
        changAutoSafes,
        changAutoStock,
        valueStock,
        changAutoBank,
        valueBank,
        changSwitch,
        uiElement,
        switchState,
        lbl,
        claslbl,
        gets,
        onChangeSearch,
        handleFocus,
        onChangeData,
        rptParams,
        setShowPaid,
        exsub,
        handClickInvs,
        infoInv,
        changIdata,
        showPaid,
        clasCAB,
        changInvs,
        loading,
        toWhere,
        buttonClassnameSavetmp,
        SaleCheckbox,
        valueCustomers,
        maxShifts,
        isStock,
        isMake,
        inputRef,
        isHedden,
        getCustomerData,
        transForm
    } = props;

    const { t } = useTranslation(["forms"]);

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbls = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();



    const clashd = useStylesHed();
    const clasSaf = useStylesAutoSafe();
    const clasBA = useStylesBA();
    const clasTD = useStylesTD();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const classes = useStyles();


    const getoptionlbl2 = (option) => {

        return `${option.name + '-' + option.id}`
    };

    const getoptionlbl = (option) => {

        return `${option.id == null ? "ابحث عن رقم الصنف" : option.id}`
    };




    const headerTitle = {
        backgroundColor: "premary",
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    }
    return (
        <div className={classes.root}>

            <Typography
                component="div"
                className="notranslate"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr", }}
            >

                <Grid item xs={12} container spacing={1} className={clasup.rootupRest1}>
                    <Grid
                        item

                        style={{
                            paddingRight: "2px",
                            color: isPurches ? colors.blue[500] : isStock ? colors.blue[500] : isMake ? colors.blue[500] : colors.green[50],
                            textAlign: "-webkit-center",
                        }}
                    >
                        <IconButton
                            color="inherit"
                            style={{
                                background: isPurches ? "#008080" : isStock ? "#3f51b5" : isMake ? "#c74375" : colors.green[500],
                                padding: "10px",
                                color: "#fff",
                            }}
                            aria-label="open drawer"
                            onClick={handleOpenCustomer}
                        >
                            <AddIcon />
                        </IconButton>
                    </Grid>
                    <Grid item lg={2} md={2} sm={3} xs={8} style={{ paddingBottom: "0.5rem" }}>

                        <Autocomplete classes={clasAo}
                            value={valueCustomers}
                            onChange={(event, newValue) => {
                                changAutoCustomers(newValue);
                            }}
                            id="combo-box-demo"
                            size="small"
                            options={optionsCustomers}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }

                            style={{}}
                            // disabled={isHedden}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={setting.cusType == 1 ? "العميل" : "المورد"}
                                    variant="outlined"
                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : isMake ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                />
                            )}

                        />
                    </Grid>

                    <Grid
                        item

                        style={{
                            paddingRight: "2px",
                            color: isPurches ? colors.blue[500] : isStock ? colors.blue[500] : colors.green[50],
                            textAlign: "-webkit-center",
                        }}
                    >
                        <IconButton
                            color="inherit"
                            style={{
                                background: "#fff",
                                padding: "5px",
                                color: isPurches ? "#008080" : isStock ? "#3f51b5" : colors.green[900],
                            }}
                            aria-label="open drawer"
                            onClick={() => {
                                getCustomerData();
                            }}
                        >
                            <Update />
                        </IconButton>
                    </Grid>

                    <Grid item lg={1} md={1} sm={2} xs={5}>
                        <Autocomplete
                            classes={clasAo}
                            value={valueSalesmen}
                            onChange={(event, newValue) => {
                                changAutoSalesMen(newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={gets.salesmen}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    id="valueSalesmen"
                                    {...params}
                                    label={transForm("delegate")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clor }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item lg={1} md={1} sm={2} xs={4}>
                        <Autocomplete
                            classes={clasAo}
                            value={valueCostcenter}
                            onChange={(event, newValue) => {
                                changAutoCostcenter(newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={gets.costcenters}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            // style={{  }}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    id="valueCostcenter"
                                    {...params}
                                    label={transForm("center")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clor }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item lg={1} md={1} sm={2} xs={4}>
                        <TextField
                            type="text"
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="id"
                            label={transForm("invoice-id")}
                            className={clasTF.root}
                            InputProps={{ className: clasTF.input, readOnly: true }}
                            name="id"
                            value={infoInv.id}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid item lg={1} md={2} sm={2} xs={4}>
                        {
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                id="date"
                                label={transForm("date")}
                                className={clasTF.root}
                                InputProps={{ className: clasTD.input }}
                                type="date"
                                format="YYYY-MM-DD"
                                InputLabelProps={{ shrink: true }}
                                name="date"
                                value={idata.date}
                                onChange={changIdata("date")}
                            />
                        }
                    </Grid>

                    <Grid item lg={1} md={1} sm={2} xs={4}>
                        <TextField
                            type="number"
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="refno"
                            label={transForm("ref-no")}
                            className={clasTF.root}
                            InputProps={{ className: clasTF.input }}
                            name="refno"
                            value={idata.refno}
                            onChange={changIdata("refno")}
                        />
                    </Grid>

                    <Grid item lg={1} md={1} sm={2} xs={3}>
                        <Autocomplete
                            classes={clasAo}
                            value={valueType}
                            onChange={(event, newValue) => {
                                changAutoType(newValue, true);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={AutoOptions.types}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            // style={{  }}
                            autoComplete={false}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    id="valueTypeF"
                                    {...params}
                                    label={transForm("invoice-type")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clor }}
                                // InputLabelProps={{shrink: true}}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item lg={1} md={2} sm={2} xs={5}>
                        <Autocomplete
                            classes={clasAo}
                            value={valueSafes}
                            onChange={(event, newValue) => {
                                changAutoSafes(newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={AutoOptions.Safes}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            style={{}}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    id="valueSafes"
                                    {...params}
                                    label={transForm("safe")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clor }}
                                //  InputLabelProps={{shrink: true}}
                                />
                            )}
                        />
                    </Grid>
                    {uiElement.bank == true && (
                        <Grid item lg={1} md={2} sm={2} xs={5}>
                            <Autocomplete
                                classes={clasAo}
                                value={valueStock}
                                onChange={(event, newValue) => {
                                    changAutoStock(newValue);
                                }}
                                id="controllable-states-demo"
                                size="small"
                                options={AutoOptions.Stocks}
                                getOptionLabel={(option) =>
                                    typeof option === "string" ? option : option.name
                                }
                                // style={{  }}

                                disableClearable
                                disabled={uiElement.stock}
                                renderInput={(params) => (
                                    <TextField
                                        id="valueStock"
                                        {...params}
                                        label={transForm("account")}
                                        variant="outlined"
                                        size="small"
                                        InputLabelProps={{ className: claslbl.clor }}
                                    />
                                )}
                            />
                        </Grid>
                    )}

                    {uiElement.bank == false && (
                        <Grid item lg={1} md={3} sm={2} xs={4}>
                            <Autocomplete
                                classes={clasAo}
                                value={valueBank}
                                onChange={(event, newValue) => {
                                    changAutoBank(newValue);
                                }}
                                id="controllable-states-demo"
                                size="small"
                                options={AutoOptions.Banks}
                                getOptionLabel={(option) =>
                                    typeof option === "string" ? option : option.name
                                }
                                className={clasup.colorSal}
                                // style={{  }}
                                disableClearable
                                disabled={uiElement.bank}
                                renderInput={(params) => (
                                    <TextField
                                        id="valueBank"
                                        {...params}
                                        label={""}
                                        variant="outlined"
                                        size="small"
                                        InputLabelProps={{ className: claslbl.clor }}
                                    />
                                )}
                            />
                        </Grid>
                    )}


                    <Grid item lg={1} md={1} sm={2} xs={4}>
                        <FormControlLabel
                            control={
                                <Tooltip title="التبديل بين شبكة وكاش">
                                    <Grid item lg={1} md={1} sm={2} xs={3}>
                                        <SaleSwitch
                                            size="small"
                                            disabled={uiElement.payMethod}
                                            checked={switchState.cashORnetworksw}
                                            onChange={changSwitch("cashORnetworksw")}
                                            id="cashORnetworksw"
                                            value="cashORnetworksw"
                                            name="cashORnetworksw"
                                        />
                                    </Grid>
                                </Tooltip>
                            }
                            className={claslbl.clorSw}
                            label={lbl.chashNetwork}
                            labelPlacement="start"
                        />
                    </Grid>

                    <Hidden only={["xs"]}>
                        <Grid item lg={2} md={2} sm={3} xs={8} style={{ paddingBottom: "0.5rem" }}>
                            <TextField
                                inputRef={inputRef}
                                type="text"
                                fullWidth
                                variant="outlined"
                                size="small"
                                id="barcode"
                                disabled={isHedden}
                                label={transForm("forms:barcode")}
                                style={{ backgroundColor: isPurches ? colors.blue[50] : isStock ? colors.blue[50] : colors.green[50] }}
                                name="barcode"
                                autoFocus={true}
                                value={rptParams.barcode}
                                InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}

                                InputProps={{
                                    onKeyDown: (event) => {
                                        if (event.key === 'Enter') {
                                            onChangeSearch(event);
                                        }
                                    },
                                }}
                                onFocus={handleFocus}
                                onChange={onChangeData("barcode")} />
                        </Grid>
                        <Grid item lg={1} md={1} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                            <TextField fullWidth variant="outlined" size="small"
                                id="trans_no"
                                label={"رقم الوردية"}
                                className={clasTF.rootSale}
                                InputProps={{ className: claslbls.clrSale, readOnly: true }}
                                InputLabelProps={{ className: claslbls.clrSale }}
                                type="text"
                                name="trans_no" value={maxShifts}
                            />
                        </Grid>
                    </Hidden>

                    <Hidden only={["xs"]}>
                        <Grid item lg={3} md={3} sm={4} xs={6} style={{ paddingBottom: "0.5rem" }}>
                            <TextField fullWidth variant="outlined" size="small"
                                id="refno"
                                label={transForm("note")}
                                className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                inputProps={{ borderColor: "black", className: claslbls.clrBlackLblS }}
                                type="text"
                                name="notes"
                                style={{ maxHeight: "3rem" }}
                                multiline
                                value={idata.notes}
                                onChange={changIdata("notes")}
                            />
                        </Grid>

                        <Grid item lg={1} md={1} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                            <FormControlLabel
                                id="showPaid"
                                value="showPaid"
                                name="showPaid"
                                className={claslbl.clor}
                                control={
                                    <SaleCheckbox
                                        checked={showPaid}
                                        onChange={(e) => {
                                            setShowPaid(e.target.checked);
                                            // changeIsPay(e.target.checked);
                                        }}
                                        color="primary"
                                    />
                                }
                                label="شاشة الدفع"
                                labelPlacement="end"
                            />
                        </Grid>
                    </Hidden>



                    {exsub > 0 ? (
                        <Grid item lg={2} md={2} sm={2} xs={4}>
                            <div className={clasCAB.wrapperCAB}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="medium"
                                    style={{
                                        ...{
                                            background: "#ff8080",
                                            color: "#fff",
                                            direction: "initial",
                                        },
                                    }}
                                    className={buttonClassnameSavetmp}
                                    disabled={loading.savetmp}
                                    onClick={() => toWhere("savetmp", "e")}
                                    startIcon={<StopIcon />}
                                >
                                    {transForm("invoice-suspension")}
                                </Button>
                                {loading.savetmp && (
                                    <CircularProgress
                                        size={24}
                                        className={clasCAB.buttonProgressCAB}
                                    />
                                )}
                            </div>
                        </Grid>
                    ) : null}
                    {setting.PrTy_InPr === "11" || setting.PrTy_InPr === "12" ? (
                        <Fragment>
                            <Grid item lg={2} md={3} sm={4} xs={6}>
                                <TextField
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="InvId_Return"
                                    label="رقم المرتجع"
                                    className={clasTF.root}
                                    InputProps={{ className: clasTF.input }}
                                    name="InvId_Return"
                                    value={infoInv.InvId_Return}
                                    onChange={changInvs("InvId_Return")}
                                    placeholder=""
                                />
                            </Grid>

                            <Grid item lg={1} md={1} sm={1} xs={1}>
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    fontSize="large"
                                    size="medium"
                                    onClick={handClickInvs}
                                >
                                    تنزيل
                                </Button>
                            </Grid>
                        </Fragment>
                    ) : (
                        <Fragment></Fragment>
                    )}
                </Grid>
                <CssBaseline />
            </Typography>

        </div>
    );
}
